export const calendarPreferencesMock = {
  id: 1,
  calendarView: 'timeGridDay',
  selectedProviders: [],
  userId: 248,
  createdAt: '2022-08-24T08:11:20.786Z',
  updatedAt: '2022-08-24T08:13:00.867Z',
  createdBy: 248,
  updatedBy: 248,
};
